import Cookie from 'js-cookie'

const SESSION_KEY = 'usersession'
const roles = 'userinfo'
const menu = 'usermenu'

export const getSession = () => {
  return Cookie.get(SESSION_KEY)
}

export const setSession = (session_id, day) => {
  return Cookie.set(SESSION_KEY, session_id, day)
}

export const removeSession = () => {
  // 同时清除 ci_session（PHP session cookie）
  removeCiSession()
  return Cookie.remove(SESSION_KEY)
}

export const removeCiSession = () => {
  Cookie.remove('ci_session')
  Cookie.remove('ci_session', { path: '/' })
  // 清除所有可能的 ci_session（含子域名残留）
  const host = window.location.hostname
  const domains = [host, host.replace(/^[^.]+\./, ''), '']
  domains.forEach(d => {
    document.cookie = 'ci_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/' + (d ? '; domain=' + d : '')
  })
}

export const getRoles = () => {
  return Cookie.get(roles)
}

export const setRoles = (data) => {
  return Cookie.set(roles, data)
}

export const removeRoles = () => {
  return Cookie.remove(roles)
}

export const getMenu = () => {
  return Cookie.get(menu)
}

export const setMenu = (data) => {
  return Cookie.set(menu, data)
}

export const removeMenu = () => {
  return Cookie.remove(menu)
}

// 写入cookie
export const setCookie = (key, value, days) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = key + "=" + (value || "") + expires + "; path=/";
}

// 读取cookie
export const getCookie = (key) => {
  var name = key + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js